module.exports = __webpack_public_path__ + "e9613137f03166e276514c5cca4f1fbf.svg";